// Die Tafel im Dashboard: nur der heutige Tag, dazu ein Feld zum Anheften.
// Die Woche und alles, was liegen geblieben ist, steht auf der Tafel selbst —
// hier reicht ein Hinweis darauf.
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../gemeinsam/lib/AuthContext';
import { useSprache } from '../../../gemeinsam/lib/i18n';
import { Karte, KartenKopf, Spinner } from '../../../gemeinsam/komponenten/Basis';
import { sortiert, tag, type Eintrag } from '../lib/tafelDaten';
import { fuellen, useTafel } from '../lib/useTafel';
import { NeuerZettel, Zettel } from './Zettel';
import { ZettelAnsehen, ZettelBearbeiten } from './ZettelFenster';

const HOECHSTENS = 9;

export default function TafelKurz() {
  const { t, sprache } = useSprache();
  const { benutzer, flags } = useAuth();
  const ich = benutzer?.id ?? '';
  const heute = tag(new Date());
  const tafel = useTafel({ von: heute, bis: heute });
  const [offen, setOffen] = useState<Eintrag | null>(null);

  // Im Dashboard nur das Eigene: mir zugewiesen oder niemandem.
  const meine = tafel.eintraege.filter(e => !e.aufgabe || !e.aufgabe.assigneeId || e.aufgabe.assigneeId === ich);
  const liegen = meine.filter(e => e.quelle === 'eigen' && e.ueberfaellig).length;
  const heuteListe = sortiert(meine.filter(e => e.datum === heute && !e.fertig && !(e.quelle === 'eigen' && e.ueberfaellig)));
  const erledigt = (e: Eintrag) => (fertig: boolean) => { if (e.aufgabe) void tafel.aendern(e.aufgabe, { column: fertig ? 'done' : 'todo' }); };
  const datum = new Date(`${heute}T12:00:00`).toLocaleDateString(sprache, { weekday: 'long', day: 'numeric', month: 'long' });

  return (
    <Karte>
      <KartenKopf titel={`${t('aufgaben.heute')} · ${datum}`}
                  hinweis={liegen
                    ? <Link to="/aufgaben" className="text-red-700 hover:underline dark:text-red-400">{fuellen(t('tafel.kurzLiegen'), { n: liegen })}</Link>
                    : t('tafel.untertitel')}
                  aktion={<Link to="/aufgaben" className="text-sm font-medium text-marke-600 hover:underline dark:text-marke-400">{t('tafel.zurTafel')} →</Link>} />
      <div className="space-y-3 p-4">
        <NeuerZettel datum={heute} team={tafel.team} beiAnlegen={tafel.anlegen} gross />
        {tafel.aufgaben === null ? <div className="flex justify-center py-6"><Spinner klein /></div>
          : heuteListe.length === 0 ? <p className="px-1 text-sm text-slate-500 dark:text-slate-400">{t('tafel.heuteFrei')}</p> : (
            <>
              <ul className="grid gap-2 sm:grid-cols-2 lg:grid-cols-3">
                {heuteListe.slice(0, HOECHSTENS).map(e => <Zettel key={e.schluessel} e={e} beiOeffnen={() => setOffen(e)} beiErledigt={erledigt(e)} />)}
              </ul>
              {heuteListe.length > HOECHSTENS && (
                <Link to="/aufgaben" className="block px-1 text-xs text-marke-700 hover:underline dark:text-marke-300">
                  {fuellen(t('tafel.weitere'), { n: heuteListe.length - HOECHSTENS })}
                </Link>
              )}
            </>
          )}
      </div>

      {offen?.aufgabe && (
        <ZettelBearbeiten key={offen.schluessel} a={offen.aufgabe} team={tafel.team} ich={ich}
                          mitTimer={flags?.advancedTasks !== false} tafel={tafel} beiSchliessen={() => setOffen(null)} />
      )}
      {offen && !offen.aufgabe && <ZettelAnsehen e={offen} tafel={tafel} ich={ich} beiSchliessen={() => setOffen(null)} />}
    </Karte>
  );
}
